import config from "config/config";
import { useTranslations, useLanguage } from "contexts/LocalizationContext/hooks";
import { getLocalizedLogotypes } from "modules/common/utils/getLocalizedLogotypes";
import { ChakraImage as Image, ChakraText as Text, ChakraFlex as Flex } from "@airhelp/react-ui-components";

interface PressLogosContentProps {
  textColor?: string;
  logoColor?: "gray" | "white";
  fontWeight?: "medium" | "bold";
}

export const PressLogosContent = ({ textColor, logoColor = "gray", fontWeight = "medium" }: PressLogosContentProps) => {
  const translations = useTranslations();
  const language = useLanguage();
  const logotypes = getLocalizedLogotypes(language);
  const imageFilter = logoColor === "gray" ? "none" : "brightness(0) invert(1)";

  return (
    <>
      <Text
        textTransform="uppercase"
        fontWeight={fontWeight}
        letterSpacing="widest"
        fontSize="xs"
        lineHeight={8}
        my={3}
        mx={2}
        color={textColor}
        data-testid="media-bar-text"
        align="center"
      >
        {translations("airhelp_has_been_featured")}
      </Text>
      <Flex flexWrap="wrap" data-testid="media-logos" justifyContent="space-evenly" flexGrow={1}>
        {logotypes.map(({ alt, imgPath }) => (
          <Image
            key={alt}
            src={`${config.staticUrl}/i/brand-logos/${imgPath}`}
            alt={alt}
            h={{ base: 7, md: 8 }}
            my={3}
            mx={4}
            loading="lazy"
            data-testid="media-bar-source"
            filter={imageFilter}
          />
        ))}
      </Flex>
    </>
  );
};
